import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';


const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'tasks',
    loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'todos',
    loadChildren: () => import('./todos/todos.module').then(m => m.TodosPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'steps',
    loadChildren: () => import('./steps/steps.module').then(m => m.StepsPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'emails',
    loadChildren: () => import('./secure-email/secure-email.module').then(m => m.SecureEmailPageModule),
    canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'new-team-user',
    loadChildren: () => import('./modals/manage-team/new-team-user/new-team-user.module').then(m => m.NewTeamUserPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'change-notification-email',
    loadChildren: () => import('./modals/manage-team/change-notification-email/change-notification-email.module').then(m => m.ChangeNotificationEmailPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'changesignature',
    loadChildren: () => import('./modals/user/settings/changesignature/changesignature.module').then(m => m.ChangesignaturePageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'file-explorer',
    loadChildren: () => import('./file-explorer/file-explorer.module').then(m => m.FileExplorerPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'create-folder',
    loadChildren: () => import('./modals/files/create-folder/create-folder.module').then(m => m.CreateFolderPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'pdf-preview',
    loadChildren: () => import('./modals/files/pdf-preview/pdf-preview.module').then(m => m.PdfPreviewPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'file',
    loadChildren: () => import('./pop-overs/files/file/file.module').then(m => m.FilePageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'folder',
    loadChildren: () => import('./pop-overs/files/folder/folder.module').then(m => m.FolderPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'activity-log',
    loadChildren: () => import('./modals/manage-team/activity-log/activity-log.module').then(m => m.ActivityLogPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'add-logo',
    loadChildren: () => import('./modals/manage-team/add-logo/add-logo.module').then(m => m.AddLogoPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'change-user-permissions',
    loadChildren: () => import('./modals/manage-team/change-user-permissions/change-user-permissions.module').then(m => m.ChangeUserPermissionsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'edit-user',
    loadChildren: () => import('./modals/manage-team/edit-user/edit-user.module').then(m => m.EditUserPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'your-account',
    loadChildren: () => import('./your-account/your-account.module').then(m => m.YourAccountPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'your-account-settings',
    loadChildren: () => import('./modals/your-account/your-account-settings/your-account-settings.module').then(m => m.YourAccountSettingsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'comment',
    loadChildren: () => import('./modals/files/comment/comment.module').then(m => m.CommentPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'settings',
    loadChildren: () => import('./modals/files/settings/settings.module').then(m => m.SettingsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'search',
    loadChildren: () => import('./modals/files/search/search.module').then(m => m.SearchPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'contacts',
    loadChildren: () => import('./clients/clients.module').then(m => m.ClientsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'table-example',
    loadChildren: () => import('./primeng/table-example/table-example.module').then(m => m.TableExamplePageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'add-client',
    loadChildren: () => import('./modals/clients/add-client/add-client.module').then(m => m.AddClientPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'companies',
    loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'select',
    loadChildren: () => import('./team-members/select/select.module').then(m => m.SelectPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'communication-log',
    loadChildren: () => import('./communication-log/communication-log.module').then(m => m.CommunicationLogPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'time-entry',
    loadChildren: () => import('./time-entry/time-entry.module').then(m => m.TimeEntryPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'payments',
    loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'file-editor',
    loadChildren: () => import('./file-editor/file-editor.module').then(m => m.FileEditorPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'file-editor',
    loadChildren: () => import('./modals/file-editor/file-editor.module').then(m => m.FileEditorPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'time-and-billing',
    loadChildren: () => import('./time-and-billing/time-and-billing.module').then(m => m.TimeAndBillingPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'surveys',
    loadChildren: () => import('./surveys/surveys.module').then(m => m.SurveysPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'signature-setup',
    loadChildren: () => import('./esignature/setup/setup.module').then(m => m.SetupPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'outlook-add-in',
    loadChildren: () => import('./outlook-add-in/outlook-add-in.module').then(m => m.OutlookAddInPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'tax-rates',
    loadChildren: () => import('./tax-rates/tax-rates.module').then(m => m.TaxRatesPageModule)
    , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'setup',
    loadChildren: () => import('./setup/setup.module').then(m => m.SetupPageModule)
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then( m => m.AppointmentsPageModule)
     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'appointments/create',
    loadChildren: () => import('./appointments/create/create.module').then(m => m.CreatePageModule)
     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'default-folder-structure',
    loadChildren: () => import('./modals/default-folder-structure/default-folder-structure.module').then( m => m.DefaultFolderStructurePageModule)
     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'companies-contacts-select',
    loadChildren: () => import('./modals/companies-contacts-select/companies-contacts-select.module').then( m => m.CompaniesContactsSelectPageModule)
     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'team-members',
    loadChildren: () => import('./team-members/team-members.module').then( m => m.TeamMembersPageModule)
     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'password-reset',
    loadChildren: () => import('./password-reset/password-reset.module').then( m => m.PasswordResetPageModule)
  },
  {
    path: 'manage-firm',
    loadChildren: () => import('./manage-firm/manage-firm.module').then( m => m.ManageFirmPageModule)     , canActivate: [AuthGuard],
    data: { preload: true }
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'missing-info',
    loadChildren: () => import('./missing-info/missing-info.module').then( m => m.MissingInfoPageModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('./calendar/calendar.module').then( m => m.CalendarPageModule)
  }




  // {
  //   path: 'billing-groups',
  //   loadChildren: () => import('./time-and-billing/billing-groups/billing-groups.module').then( m => m.BillingGroupsPageModule)
  // }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }


